export const NEW_ENTITY_IDS = {
  admin: 'new-admin',
  invitee: 'new-invitee',
};
